import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  selectAuthAccountType,
  selectAuthPermissionSubjectUserId,
} from "../../Redux/authPermissions/authPermissionsSlice";
import { setFlaggedPageCount } from "../../Redux/general/actions";
import { AUTH_ACCOUNT_TYPES } from "../../auth/permissions.mjs";

import { startFlaggedCaseCount } from "./flaggedCaseCount";

export default function FlaggedCaseCountBridge({ isAuthenticated }) {
  const dispatch = useDispatch();
  const userId = useSelector(selectAuthPermissionSubjectUserId);
  const accountType = useSelector(selectAuthAccountType);

  useEffect(() => {
    // The account type is only known right after login; after a page refresh it is null,
    // so only a known non-firm login is skipped. The socket closes with 4403 for the rest.
    const isNonFirmLogin =
      Boolean(accountType) && !Object.values(AUTH_ACCOUNT_TYPES).includes(accountType);
    if (!isAuthenticated || isNonFirmLogin || !userId) {
      dispatch(setFlaggedPageCount(0));
      return;
    }
    return startFlaggedCaseCount(userId, dispatch);
  }, [isAuthenticated, accountType, userId, dispatch]);

  return null;
}
